<template>
  <div class="mx-md-12 px-sm-12 align--center">
    <p class="display-1 primary--text text-center">Gemeinsames Mittagessen</p>

    <p>
    Gerne begrüßen wir Gäste bei unserem offenen Mittagstisch. Täglich stehen je zwei Menüs zur Auswahl. Nach telefonischer Vereinbarung und Anmeldung können Sie gerne vorbeikommen.
    Die Abrechnung erfolgt monatlich.
    </p>
    
    <div class="text-center">
      <img
      class="hidden-sm-and-down"
      width="50%"
      :src="require('@/assets/Angebote/Gemeinsames_Mittagessen/Gedeck.jpg')"
      />

      <img
      class="hidden-md-and-up"
      width="100%"
      :src="require('@/assets/Angebote/Gemeinsames_Mittagessen/Gedeck.jpg')"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'gemeinsames_mittagessen',
  }
</script>
